import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <section id="problem-section" className="py-24 bg-gray-50" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <div className="text-center mb-16" data-id="element-278">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-279">
            Building metered AI is harder than it should be
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-280">
            You want to charge customers for AI usage (pay-as-you-go). But you
            end up rebuilding the same infrastructure every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-281">
          {/* Problem 1 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-282">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-283">AI Gateway</h3>
            <div className="space-y-4 mb-8" data-id="element-284">
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-285">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-286" />
                <span data-id="element-287">Build: Custom API layer for each LLM provider</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-288">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-289" />
                <span data-id="element-290">
                  Build: Handle different formats (OpenAI, Anthropic, etc)
                </span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-291">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-292" />
                <span data-id="element-293">Build: Manage API keys, retries, errors, fallbacks</span>
              </div>
            </div>
            <div className="pt-6 border-t border-gray-100" data-id="element-294">
              <div className="flex items-start gap-3 text-sm font-semibold text-green-700" data-id="element-295">
                <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-296" />
                <span data-id="element-297">
                  TokenGates: OpenAI-compatible API, routes to 100+ providers
                </span>
              </div>
            </div>
          </div>

          {/* Problem 2 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-298">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-299">
              Cost Attribution
            </h3>
            <div className="space-y-4 mb-8" data-id="element-300">
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-301">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-302" />
                <span data-id="element-303">Build: Log every request, count tokens per user</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-304">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-305" />
                <span data-id="element-306">Build: Calculate cost per customer, per model</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-307">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-308" />
                <span data-id="element-309">Build: Store usage data and sync to billing</span>
              </div>
            </div>
            <div className="pt-6 border-t border-gray-100" data-id="element-310">
              <div className="flex items-start gap-3 text-sm font-semibold text-green-700" data-id="element-311">
                <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-312" />
                <span data-id="element-313">
                  TokenGates: Automatic real-time tracking, cost attribution
                </span>
              </div>
            </div>
          </div>

          {/* Problem 3 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-314">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-315">
              Metered Billing
            </h3>
            <div className="space-y-4 mb-8" data-id="element-316">
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-317">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-318" />
                <span data-id="element-319">Build: Create Stripe/Polar billing meters</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-320">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-321" />
                <span data-id="element-322">Build: Write webhook handlers to sync usage</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-600" data-id="element-323">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-324" />
                <span data-id="element-325">Build: Implement spend limits, prevent overage</span>
              </div>
            </div>
            <div className="pt-6 border-t border-gray-100" data-id="element-326">
              <div className="flex items-start gap-3 text-sm font-semibold text-green-700" data-id="element-327">
                <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-328" />
                <span data-id="element-329">
                  TokenGates: Auto-creates meters, syncs in real-time, enforces
                  limits
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}